import React from "react";
import Sideform from "../Sideform";
import ShareButtons from "../../../utility/ShareButtons";
import FAQAccordion from "../../../utility/FAQAccordion";
import QuickNavigation from "../../../utility/serviceTemplateutility/QuickNavigation";
import CardDesign from "../../../utility/serviceTemplateutility/CardDesigntwo";
import ListDesign from "../../../utility/serviceTemplateutility/ListDesigntwo";
import CheckList from "../../../utility/serviceTemplateutility/CheckList";
import WhyUs from "../../../utility/serviceTemplateutility/WhyUs";
import MultiStepForm from "../../../utility/serviceTemplateutility/MultiStepForm";

const PShot = () => {
  const serviceUrl = window.location.href;
  const faqData = [
    { heading: "Frequently Asked Questions" },
    {
      question: "Is the P-Shot painful?",
      answer:
        "No, the P-Shot is virtually painless. A numbing cream is applied to ensure comfort during the procedure, and most patients report feeling little to no discomfort.",
    },
    {
      question: "How soon will I see results?",
      answer:
        "Some men notice an improvement in their erections and sexual performance within a few days of the procedure. Full benefits typically emerge after a few weeks as the PRP works to regenerate tissue and improve blood flow.",
    },
    {
      question: "How long do the results last?",
      answer:
        "Results can last up to 18 months or longer, depending on individual factors such as age, overall health, and lifestyle habits.",
    },
    {
      question: "Are there any side effects?",
      answer:
        "Since the P-Shot uses your own blood, there is little risk of allergic reactions or major side effects. Mild swelling or bruising at the injection site may occur but typically resolves within a few days.",
    },
    {
      question: "How many treatments will I need?",
      answer:
        "Many patients achieve satisfactory results with just one treatment. However, some may benefit from additional sessions depending on their specific needs and health conditions.",
    },
  ];

  const benefits = [
    { heading: "Benefits of the P Shot" },
    {
      title: "Improves Erectile Function",
      description:
        "Enhances blood circulation for stronger, longer-lasting erections.",
      icon: "fa-solid fa-heart",
    },
    {
      title: "Increases Sensitivity & Pleasure",
      description: "Boosts nerve response for a heightened experience.",
      icon: "fa-solid fa-microchip",
    },
    {
      title: "Enhances Stamina & Performance",
      description: "Supports longer endurance and better control.",
      icon: "fa-solid fa-running",
    },
    {
      title: "Non-Surgical & Safe",
      description:
        "Uses your body’s own PRP, reducing risks of allergic reactions or complications.",
      icon: "fa-solid fa-user-md",
    },
    {
      title: "Effectively Treats Erectile Dysfunction (ED)",
      description: "A natural, long-term solution for men struggling with ED.",
      icon: "fa-solid fa-pills",
    },
    {
      title: "Boosts Confidence",
      description: "Helps you regain vitality and self-assurance.",
      icon: "fa-solid fa-smile-beam",
    },
  ];

  const procedureSteps = [
    { heading: "How Does the P Shot Work?" },
    {
      para: "This quick, painless procedure takes just 30–45 minutes and requires no downtime.",
    },
    {
      title: "Blood Draw",
      description: "A small blood sample is taken from your arm.",
      icon: "fa-solid fa-syringe",
    },
    {
      title: "PRP Extraction",
      description:
        "The blood is processed to extract Platelet-Rich Plasma (PRP), rich in growth factors.",
      icon: "fa-solid fa-flask",
    },
    {
      title: "Targeted Injection",
      description:
        "PRP is precisely injected into penile tissue to stimulate cell repair, improve circulation, and enhance function.",
      icon: "fa-solid fa-inject",
    },
  ];

  const targetAudience = [
    { text: "Men struggling with erectile dysfunction (ED) or weak erections" },
    { text: "Those looking to enhance sensitivity and sexual pleasure" },
    { text: "Individuals facing low stamina or performance anxiety" },
    { text: "Men seeking a natural, drug-free alternative to ED medications" },
  ];

  return (
    <>
      <title>P Shot Treatment in Dubai - Priapus Shot for Men</title>
      <meta
        name="description"
        content="Revitalize Your Intimate Wellness with the P-Shot treatment in Dubai at Elite Body Home. Enhance performance and improve overall wellness with P shot therapy."
      />
      <meta
        name="robots"
        content="follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
      />
      <link
        rel="canonical"
        href="https://elitebodyhome.com/services/p-shot-treatment-dubai/"
      />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="article" />
      <meta
        property="og:title"
        content="P Shot Treatment in Dubai - Priapus Shot for Men"
      />
      <meta
        property="og:description"
        content="Revitalize Your Intimate Wellness with the P-Shot treatment in Dubai at Elite Body Home. Enhance performance and improve overall wellness with P shot therapy."
      />
      <meta
        property="og:url"
        content="https://elitebodyhome.com/p-shot-treatment-dubai/"
      />
      <meta property="og:site_name" content="elitebodyhome.com" />
      <meta property="og:updated_time" content="2025-02-26T15:37:55+00:00" />
      <meta
        property="og:image"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-6.jpg"
      />
      <meta
        property="og:image:secure_url"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-6.jpg"
      />
      <meta property="og:image:width" content="1254" />
      <meta property="og:image:height" content="700" />
      <meta property="og:image:alt" content="P Shot" />
      <meta property="og:image:type" content="image/jpeg" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="P Shot Treatment in Dubai - Priapus Shot for Men"
      />
      <meta
        name="twitter:description"
        content="Revitalize Your Intimate Wellness with the P-Shot treatment in Dubai at Elite Body Home. Enhance performance and improve overall wellness with P shot therapy."
      />
      <meta
        name="twitter:image"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-6.jpg"
      />
      <div className="min-vh-100 font-sans text-dark mb-5 mx-3">
        <div className="container-fluid px-0 py-4">
          <div className="row justify-content-center">
            <div>
              <div
                className="rounded-4 overflow-hidden shadow-sm"
                style={{ border: "2px solid #c69933" }}
              >
                <div className="row g-0 align-items-stretch">
                  {/* Image Column - Left Side */}
                  <div className="col-lg-6">
                    <img
                      loading="lazy"
                      decoding="async"
                      src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/p-shot-large.jpg"
                      className="img-fluid w-100 h-100 object-fit-cover"
                      alt="Aqualyx fat dissolving injections in Dubai | Elite Body Home"
                      style={{
                        minHeight: "400px",
                        maxHeight: "720px",
                      }}
                    />
                  </div>

                  {/* Content Column - Right Side */}
                  <div className="col-lg-6 d-flex align-items-center bg-white">
                    <div
                      className="p-4 p-md-5 w-100"
                      style={{ maxWidth: "600px", margin: "0 auto" }}
                    >
                      <h1
                        className="display-5 fw-bold mb-3"
                        style={{
                          color: "#c69933",
                        }}
                      >
                        P Shot Treatment in Dubai
                      </h1>
                      <p className="fs-5 text-secondary mb-4">
                        Enhance Your Intimate Wellness &amp; Performance with
                        the Priapus (P) Shot!
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex gap-4  w-100 ">
          <div
            className=" rounded-4 p-2 bg-white flex-grow-1 "
            style={{
              width: "65%",
              border: "2px solid #c69933",
            }}
          >
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="/home">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Services
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  P Shot Treatment in Dubai
                </li>
              </ol>
            </nav>
            <QuickNavigation />
            <div>
              <h2 className="title">What is the P Shot?</h2>
            </div>
            <div>
              <p>
                The Priapus Shot (P Shot) is a revolutionary, non-surgical
                treatment designed to enhance male sexual performance, stamina,
                and confidence using Platelet-Rich Plasma (PRP) therapy. This
                cutting-edge procedure harnesses your body’s natural healing
                ability to stimulate tissue regeneration, improve blood flow,
                and boost sensitivity.
              </p>
              <p>
                At <strong>Elite Body Home Polyclinic</strong> in Dubai, we
                provide safe, discreet, and highly effective P-Shot treatments
                performed by expert medical professionals.
              </p>
            </div>
            <div id="benefits">
              <CardDesign carditems={benefits} />
            </div>

            <div id="procedures">
              <ListDesign listitems={procedureSteps} />
            </div>

            <div id="preparations">
              <CheckList
                items={targetAudience}
                title="  Who Can Benefit from the P Shot?"
              />
            </div>

            <WhyUs language="en" />
            <FAQAccordion faqData={faqData} />
            <ShareButtons url={serviceUrl} />
          </div>
          <MultiStepForm />
        </div>
      </div>
    </>
  );
};

export default PShot;
